var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tfaIsEnabled
        ? _c("div", [
            _c("p", { staticClass: "emd-text _color_subtle eu-mt_3" }, [
              _vm._v(" " + _vm._s(_vm.$t("description")) + " "),
              _c("strong", [_vm._v(_vm._s(_vm.$t("description-part2")))]),
              _vm._v(" " + _vm._s(_vm.$t("description-part3")) + " "),
              _c("strong", [_vm._v(_vm._s(_vm.$t("description-part4")))]),
              _vm._v(" " + _vm._s(_vm.$t("description-part5")) + " "),
            ]),
            _c(
              "button",
              {
                staticClass:
                  "emd-btn _color_info _type_outline _block_mobile eu-basis_4 eu-basis_4_lg eu-basis_4_xl eu-basis_6_md eu-basis_6_sm eu-basis_12_mobile eu-mt_4 position-relative",
                on: { click: _vm.activeDeleteModal },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("reset-button")))]),
                _c("i", {
                  staticClass: "uil uil-padlock eu-ml_2 padlock-button",
                }),
              ]
            ),
          ])
        : _c(
            "div",
            { staticClass: "eu-pt_2 max-width" },
            [
              _c(
                "emd-alert",
                {
                  attrs: {
                    variant: "info",
                    title: _vm.$t("alert-title"),
                    autoclose: false,
                  },
                },
                [
                  _c("template", { slot: "content" }, [
                    _vm._v(" " + _vm._s(_vm.$t("alert-description")) + " "),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
      _c("tfa-modal", {
        attrs: { modalState: _vm.tfaModalState },
        on: {
          "update:modalState": function ($event) {
            _vm.tfaModalState = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }